import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import ModalCloseButton from './ModalCloseButton';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialMode?: 'login' | 'register';
  onLoginSuccess?: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, initialMode = 'login', onLoginSuccess }) => {
  const [mode, setMode] = useState<'login' | 'register' | 'forgot-password' | 'reset-password'>(initialMode);
  const [resetToken, setResetToken] = useState<string>('');
  const [resetEmail, setResetEmail] = useState<string>('');

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: isMobile ? 'var(--color-bg-primary)' : 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        zIndex: 100000,
        padding: isMobile ? '0' : '40px 16px 16px',
        paddingTop: isMobile ? 'env(safe-area-inset-top, 0px)' : '40px',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch' as any,
      }}
      onClick={isMobile ? undefined : handleBackdropClick}
    >
      <div style={{
        position: 'relative',
        maxWidth: isMobile ? 'none' : '480px',
        width: '100%',
        maxHeight: isMobile ? 'none' : '90vh',
        overflowY: isMobile ? 'visible' : 'auto',
        backgroundColor: 'var(--color-bg-primary)',
        borderRadius: isMobile ? '0' : '12px',
        boxShadow: isMobile ? 'none' : '0 10px 25px rgba(0, 0, 0, 0.2)',
        paddingBottom: isMobile ? '50vh' : '0',
      }}>
        <ModalCloseButton
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            zIndex: 10,
          }}
        />
        
        {mode === 'login' && (
          <LoginForm 
            onSwitchToRegister={() => setMode('register')}
            onSwitchToForgotPassword={() => setMode('forgot-password')}
            onClose={onClose}
            onLoginSuccess={onLoginSuccess}
          />
        )}
        
        {mode === 'register' && (
          <RegisterForm 
            onSwitchToLogin={() => setMode('login')}
            onClose={onClose}
            onLoginSuccess={onLoginSuccess}
          />
        )}
        
        {mode === 'forgot-password' && (
          <ForgotPasswordForm
            onBack={() => setMode('login')}
            onResetTokenReceived={(token, email) => {
              setResetToken(token);
              setResetEmail(email);
              setMode('reset-password');
            }}
          />
        )}
        
        {mode === 'reset-password' && (
          <ResetPasswordForm
            token={resetToken}
            email={resetEmail}
            onSuccess={() => {
              setMode('login');
              // Could show a success message here
            }}
            onBack={() => setMode('login')}
          />
        )}
      </div>
    </div>
  );
};

export default AuthModal;
